import { Title, PageTitleContainer } from './styled';

type PageTitleProps = {
    title: React.ReactNode;
    extra?: React.ReactNode;
};

const PageTitle = ({ title, extra }: PageTitleProps) => (
    <PageTitleContainer>
        <Title>{title}</Title>
        {extra}
    </PageTitleContainer>
);

export default PageTitle;
